<template>
  <div>
    <form @keyup.enter="handleSaveClick()" class="modal-form" ref="firewallForm">
      <custom-input
        required
        inputType="text"
        placeholder="Название"
        labelText="Название"
        v-model="model.name"
        :errorMessage="model.validator['name']"
        :inputValue="model.name"
        name="name"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Высота, м"
        labelText="Высота, м"
        v-model="model.H"
        :errorMessage="model.validator['H']"
        :inputValue="model.H"
        name="H"
      />
    </form>

    <div class="modal-footer-buttons">
      <main-button type="button" @click="handleSaveClick()">Сохранить</main-button>
      <main-button color="link" type="button" @click="$emit('onCancelClick')">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import "vue-form-generator/dist/vfg.css";
import MainButton from "../../components/ui/MainButton.vue";
import CustomInput from "../../components/ui/Input.vue";
import { scrollToErrorInput } from "../../utils/utils.js";

export default {
  name: "FirewallEdit",
  components: { MainButton, CustomInput },
  props: {
    proj_id: Number,
    newFirewall: Object,
    substrate: Object,
    firewalls: Array,
  },
  mounted() {
    if (this.newFirewall) {
      Object.assign(this.model, this.newFirewall);
    }
  },
  data() {
    return {
      model: {
        name: "Противопожарная стена",
        H: 1,
        validator: {},
      },
    };
  },
  methods: {
    save() {
      if (!this.newFirewall.id) {
        this.$http
          .post("risk/firewalls/firewall-add?proj_id=" + this.proj_id, this.model)
          .then((response) => {
            this.firewalls.unshift(response.data);
            // JSON responses are automatically parsed.
            this.$emit("hide");
            this.$emit("clearCalculations");
          })
          .catch((e) => {
            this.$set(this.model, "validator", {});
            this.$set(this.model, "validator", e.response.data);
            this.$refs.form.validate();
          });
      } else {
        this.$http
          .post("risk/firewalls/firewall-update?id=" + this.newFirewall.id, this.model)
          .then((response) => {
            this.$set(this.firewalls, this.newFirewall.index, response.data);
            // JSON responses are automatically parsed.
            this.$emit("hide");
            this.$emit("clearCalculations");
          })
          .catch((e) => {
            this.$set(this.model, "validator", {});
            this.$set(this.model, "validator", e.response.data);
            this.$refs.form.validate();
          });
      }
    },

    validate() {
      this.model.validator = {};
      const errors = {};
      let isValid = true;
      const elementNames = [
        ...Array.from(this.$refs.firewallForm.elements)
          .map((element) => element.name)
          .filter((item) => Boolean(item)),
      ];
      elementNames.forEach((item) => {
        if (this.model[item] !== 0 && this.model[item] !== "0" && !this.model[item]) {
          isValid = false;
          errors[item] = "Необходимо заполнить поле";
        }
      });
      scrollToErrorInput(errors, this.$refs.firewallForm);
      this.model.validator = errors;
      return isValid;
    },

    handleSaveClick() {
      if (this.validate()) {
        this.save();
      }
    },
  },
};
</script>
